var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1674 13.3332V16.8332H23.6674V19.1665H20.1663L20.1674 22.6665H17.8341L17.8329 19.1665H14.3341V16.8332H17.8341V13.3332H20.1674ZM21.617 2.55025C24.2565 5.19515 24.3474 9.40864 21.8934 12.1573L20.2373 10.503C21.7891 8.72486 21.7074 5.93653 19.9655 4.19845C18.2125 2.44941 15.3928 2.37485 13.5605 4.01969L12.0029 5.41778L10.4444 4.02078C8.60679 2.37363 5.78822 2.44611 4.03415 4.20018C2.29612 5.9382 2.20886 8.72183 3.81057 10.5604L13.648 20.4138L12.0005 22.0658L2.10893 12.1585C-0.346126 9.40981 -0.254356 5.18885 2.38424 2.55025C5.02581 -0.091324 9.25337 -0.180318 12.0018 2.28329C14.7423 -0.176666 18.9773 -0.094999 21.617 2.55025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.8fe09ceffbcb7107a565eab8d4c5785d.svg";
export { ForwardRef as ReactComponent };